import { Button, Grid, Input, Loading, Spinner, Text } from "@nextui-org/react";
import { motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";
import { TbArrowBackUp } from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useInput2 } from "../../hooks/useInput";
import Inputs from "./inputs";
import Stock from "./ipods";
import Variants from "./variants";

const AddProduct = () => {
  const token = useSelector((state) => state.invtry.token);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [type, setType] = useState("iPhone");
  const [variants, setVariants] = useState([]);
  const router = useNavigate();

  const { input: name } = useInput2((v) => v !== "", "");
  const [target, setTarget] = useState("sync_all");
  const { input: link } = useInput2((v) => v !== "", " ");
  const { input: desc } = useInput2((v) => v !== "", " ");
  const { input: quantity } = useInput2((v) => v >= 0, "");
  const { input: price } = useInput2((v) => v >= 0, "");
  const { input: myPrice } = useInput2((v) => v >= 0, "");
  const { input: stock } = useInput2((v) => v !== "", "");

  const loadHandler = async () => {
    setLoading(true);
    setError(false);
    let doc = {};

    if (type === "iPod") {
      doc = {
        basic: {
          name: name.inputValue,
          link: link.inputValue,
          short_desc: desc.inputValue,
          quantity:
            quantity.inputValue && quantity.inputValue >= 0
              ? quantity.inputValue
              : 0,
          isInStock: true,
          price: price.inputValue,
          my_price: myPrice.inputValue,
        },
      };
    } else {
      doc = {
        basic: {
          name: name.inputValue,
          link: link.inputValue,
          short_desc: desc.inputValue,
        },
        variants: variants,
      };
    }

    await fetch("https://stockmanager-api.vercel.app/add-product", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...doc,
        type,
        target,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.success) {
          setError(true);
          return setLoading(false);
        }

        window.alert("SUCCESS");
        router("/analytics");
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        return setLoading(false);
      });
  };

  return (
    <>
      <motion.div className="header">
        <Link to="/analytics" className="headerLink">
          <TbArrowBackUp className="icoAdjust" />
        </Link>
        <Text b>Add Product</Text>
        <div className="headerLink">
          <Button
            auto
            size={"sm"}
            disabled={
              !name.isValid ||
              !link.isValid ||
              !desc.isValid ||
              (type === "iPod"
                ? !price.isValid || !myPrice.isValid
                : variants?.length <= 0) ||
              loading
            }
            onClick={loadHandler}
          >
            {loading ? <Loading type="spinner" color={"error"} /> : "Save"}
          </Button>
        </div>
      </motion.div>
      <motion.div className="qtyContainer alignDivCenter">
        <Grid.Container gap={1} css={{ maxW: 775 }}>
          <Grid xs={12}>
            <Text h5>Basic Details</Text>
          </Grid>
          <Grid
            xs={12}
            md={3}
            css={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: 0,
            }}
          >
            <div className="selectCustom">
              <select
                id="select"
                value={type}
                onChange={(event) => setType(event.target.value)}
                aria-label="Select Category"
                defaultValue={""}
                style={{ border: "none", width: "100%" }}
              >
                <option value={"iPhone"}>iPhone</option>
                <option value={"iPod"}>iPod</option>
                <option value={"iWatch"}>iWatch</option>
              </select>
            </div>
          </Grid>
          <Grid
            xs={12}
            md={3}
            css={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: 0,
            }}
          >
            <div className="selectCustom">
              <select
                id="select"
                value={target}
                onChange={(event) => setTarget(event.target.value)}
                aria-label="Select List"
                defaultValue={"sync_all"}
                style={{ border: "none", width: "100%" }}
              >
                <option value="sync_all">Sync All</option>
                <option value="main">Main List</option>
                <option value="alt">Alt</option>
                <option value="sunil">Sunil</option>
                <option value="threeH">3H</option>
              </select>
            </div>
          </Grid>
          <Inputs name={name} link={link} desc={desc} />
          {type === "iPod" && (
            <>
              <Grid xs={12} css={{ mt: 20 }}>
                <Text h5>Price & Stock</Text>
              </Grid>
              <Stock
                quantity={quantity}
                price={price}
                myPrice={myPrice}
                stock={stock}
              />
            </>
          )}
          {type !== "iPod" && (
            <>
              <Grid xs={12} css={{ mt: 20 }}>
                <Text h5>Variants</Text>
              </Grid>
              <Variants
                variants={variants}
                setVariants={setVariants}
                type={type}
              />
            </>
          )}
        </Grid.Container>
      </motion.div>
    </>
  );
};

export default AddProduct;
